<template>
  <div class="grid-cell">
    <a
      :href="previewProject"
      target="_parent _blank"
    >{{ data.projectId }}</a>
  </div>
</template>

<script>
import eInsightUrl from '../../constants/eInsightUrl'
export default {
  data () {
    return {
    }
  },
  computed: {
    previewProject () {
      return this.$store.getters.getEinsightUri + eInsightUrl.preview(this.data.projectId)
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: black;
}
.grid-cell {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
